import React, { useEffect, useState, useContext } from "react";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Button,
  InputLabel,
} from "@material-ui/core";
import { Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import {

  ListItem,
  Checkbox,

} from "@material-ui/core";
import Select from "@material-ui/core/Select/Select";
import CustomSelect from "../../../../../../Components/CustomSelect";

import FormControlLabel from "@material-ui/core/FormControlLabel";
// import { Checkbox } from "@material-ui/core";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from "@material-ui/core/Grid";
import Box from '@material-ui/core/Box';
import Cancellation from './Cancellation';
import Objective from './Objective';
import Stakeholder from './Stakeholder';
import Timeline from './Timeline';
import Paper from "@material-ui/core/Paper";
import DataClient from '../../../../../../Service/general_data_service';
import CopyToClipboard from "../../../../../../Components/copy_to_clipboard";
import DataService from "../../../../../../Service";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../../../../Components/CustomInput";
import { showSnackbar } from "../../../../../../Components/Snackbar/SnackbarActions";
import Zoom from "@material-ui/core/Zoom";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Fab from "@material-ui/core/Fab";
import useHideOnScrolled from "../../../../../../Components/UseHideOnScrolled";


const useStyles = makeStyles((theme) => ({
  tabRoot: {

    '& .MuiTabs-flexContainer': {
      justifyContent: "flex-start"
    },
    '& .MuiTabs-indicator': {
      backgroundColor: "transparent"
    }
  },
  tabs: {
    color: "#1e1e1e",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#ddd",
    backgroundColor: "rgba(7,127,131,1)",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    marginRight: 10,
    marginBottom: 30,
    fontSize: "18px",
    minWidth: 130,
    textTransform: "capitalize",
    // "&.Mui-selected": {

    //   color: sessionStorage.getItem('role') == 'admin' ? '#3B86FF' : '#981B1E',
    //   backgroundColor: "#fff",
    // }
    
    "&:hover,&.Mui-selected": {
      color: "#fff",
      backgroundColor: "rgba(7,127,131,1)",
      opacity: 1,
    }
  },
  root: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(10)
  },
  stepperButtons: {
    position: "fixed",
    display: "flex",
    justifyContent: "space-between",
    bottom: "0px",
    backgroundColor: "white",
    padding: "10px 0px 20px 0px",
    zIndex: 1,
  },

}));



function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Box role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`} {...other}>
      {value === index && children}
    </Box>
  );
}
let first = true;
export default function Caf(props) {

  const classes = useStyles();
  const [pageData, setPageData] = React.useState([]);
  const [ctcUrl, setCtcUrl] = React.useState('');
  const [slugId, setSlugId] = React.useState('');
  const [value, setValue] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const [CoachinRequest, setCrfSection] = useState([]);
  const [crfAnswers, setCrfAnswers] = useState([]);
  const dispatch = useDispatch();
  const sessionStorage = window.sessionStorage.getItem("slug");
  const [userData, setUserData] = useState();
  const [action, setAction] = useState(null);
  const [crfSectionId, setCrfSectionId] = useState("");
  const [currentSelection, setCurrentSelection] = useState({});
  const [additionalSection, setAdditionalSectionId] = useState("");
  const [assignmentId, setAssignmentId] = useState("");
  const [crfId, setCrfId] = useState('');
  const hidden = useHideOnScrolled();

  const [answerData, setAnswerData] = useState({});
  let quesArr = []
  const handleChange = (event, newValue) => {
    setValue(newValue);
    CafFetch()
  };

  let sectionId = '';
  let crfFromId = ''
  function a11yProps(index, item) {
    console.log('item321', item)
    sectionId = item.id;
    crfFromId = item.id;
    //   setCrfSectionId(item.id)
    //   setCrfFormId(item.coaching_request_form_id)
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  }

  const copyUrl = useSelector((state) => state.commonReducer)?.accessPermission?.assignmentDetail.caf.copyURL

  const tabArr = ["Stakeholders", "Timelines and Logistics", "Cancellation and Termination", "Objectives"]
  // const tabPanelArr = [
  //   <Stakeholder tabIndex={value} pageData={pageData} assignment_id={props.location?.state?.currentAssignment?.id} parentCall={setValue} />,
  //   <Timeline tabIndex={value} pageData={pageData} assignment_id={props.location?.state?.currentAssignment?.id} parentCall={setValue} />,
  //   <Cancellation tabIndex={value} pageData={pageData} assignment_id={props.location?.state?.currentAssignment?.id} parentCall={setValue} />,
  //   <Objective tabIndex={value} assignment_id={props.location?.state?.currentAssignment?.id} parentCall={setValue} />
  // ]

  const CafFetch = () => {
    DataService.getDirectData(`/coaching_agreement_form_answers/view_caf?assignment_id=${props.location?.state?.currentAssignment?.id}`).then(
      (res) => {
        if (res.coaching_agreement_form) {
          // console.log(`res.id`, res.id)
          setCrfId(res.coaching_agreement_form.id)
          setCtcUrl(res.coaching_agreement_form.slug)
          window.sessionStorage.setItem('slug', res.coaching_agreement_form.slug);
          let CoachinRequests = res.coaching_agreement_form.coaching_agreement_form_sections;
          setCrfSection(CoachinRequests);
          setAssignmentId(res.coaching_agreement_form.assignment_id)
          localStorage.clear();
          // setLoading(false);
        }
      }
    );
  };
  // const setInputState = (inputStateValue, inputId) => {
  //   console.log(`object`, inputStateValue, inputId)
  //   setAnswerData({ ...answerData, [inputId]: inputStateValue });
  //   setUserData({ ...userData, [inputId]: inputStateValue });
  // };
  const onChangeItem = (selectedItemValue) => {
    setUserData({ ...userData, [selectedItemValue.id]: selectedItemValue.value });
     setAnswerData({ ...answerData, [selectedItemValue.id]: selectedItemValue.value  });
};
 const setInputState = (inputStateValue, inputId, childId,checkBoxFlag=false) => {
    console.log(`object`, answerData, inputStateValue, inputId);
    if (childId) {
      const childObj = { ...answerData[inputId], [childId]: inputStateValue };
      setAnswerData({
        ...answerData,
        [inputId]: Object.keys(childObj).filter((item, index) =>
          Boolean(childObj[item])
        ),
      });
      setUserData({
        ...userData,
        [inputId]: { ...answerData[inputId], [childId]: inputStateValue },
      });
    } else {
      const answerKeys = Object.keys(answerData);

      if (answerKeys.length > 0 && answerKeys.includes(inputId.toString())) {
        if (!answerData[inputId].includes(inputStateValue)) {
          setAnswerData((prev) => {
            return {...prev, [inputId]:checkBoxFlag?[...prev[inputId], inputStateValue]:inputStateValue };
          });
        } else {
          let copy = answerData[inputId].filter((el) => el !== inputStateValue);
          setAnswerData((prev) => {
            return {
              ...prev,
              [inputId]: copy,
            };
          });
        }
      } else {
        setAnswerData({ ...answerData, [inputId]:checkBoxFlag? [inputStateValue]:inputStateValue });
      }
      setUserData({ ...userData, [inputId]: inputStateValue });
    }
  };

  const handleSubmit = () => {
    for (var i in answerData) {
      quesArr.push({ coaching_agreement_form_field_id: i, value: answerData[i] })
    }
    const statusData = {
      coaching_agreement_form_section_id: crfFromId,
      additional_section_id: additionalSection,
      assignment_id: assignmentId,
      caf_answers: JSON.stringify(quesArr)
    }
    DataService.createData(statusData, "coaching_agreement_form_answers")
      .then((res) => {
        CafFetch()

        if ((value + 1) < CoachinRequest.length) {

          setValue(value + 1)
          dispatch(showSnackbar("success", ["Success!"]));
        }
        dispatch(showSnackbar("success", ["Success!"]));
      })
      .catch((err) => {
        // setLoading(false);
        dispatch(showSnackbar("error", [["" + err.errors]]));
      });
  };
  console.log(answerData,"answer data")
  useEffect(() => {
    // setLoading(true);
    CafFetch();
    return () => {
      first = true;
    };
  }, []);
  const [scrolling, setScrolling] = useState(false);
  function ScrollTop(props) {
    const { children } = props;
    const classes = useStyles();
    const trigger = useScrollTrigger({
      disableHysteresis: true,
      threshold: 50
    });
    const handleClick = event => {
      const anchor = (event.target.ownerDocument || document).querySelector(
        "#back-to-top-anchor"
      );

      if (anchor) {
        anchor.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };

    return (
      <Zoom in={trigger}>
        <div onClick={handleClick} role="presentation" className={classes.root}>
          {children}
        </div>
      </Zoom>
    );
  }
  console.log('scrolling', scrolling)
  const checkAnswer = (answer, childId, rowID) => {
    // debugger
    if (answer?.length && typeof answer === 'object') {
      const ids = answer.map(item => item.id) || []
      let checked = ids.includes(childId);
      if (checked) {
        return checked;
      } else {
        if (answerData && answerData[rowID]?.length) {
          const stateData = answerData[rowID].find(item => +item === childId)
          return Boolean(stateData)
        }
        return false;
      }
    }
  }
  return <>
    <Grid container direction="row" justify="center" alignItems="center">
      <Grid item xs={11} style={{ marginTop: "40px" }}>
        <Box mb={5} >
          <Tabs value={value} variant="scrollable"
            scrollButtons="auto" onChange={handleChange} classes={{ root: classes.tabRoot }}>

            {CoachinRequest.length > 0 && CoachinRequest.map((item, index) => {
              return (
                <Tab

                  label={item.section_name}
                  classes={{ root: classes.tabs }}
                  {...a11yProps(index, item)}
                />
              );
            })}
          </Tabs>
          {CoachinRequest.length > 0 && CoachinRequest.map((item, index) => {
            return (
              <TabPanel style={{ width: "93%" }} value={value} index={index}>
                {/* {CoachinRequest[index].additional_sections.map((tempArr, addIndex) => (
                  <React.Fragment>
                    <Grid
                      container
                      direction="row"
                      alignItems="flex-start"
                      style={{ margin: "16px 0px", backgroundColor: '#F2F2F2' }}
                    >
                      <Grid
                        item
                        xs={10}
                      >
                        <InputLabel
                          className={classes.labelText}
                          style={{ fontWeight: "bold", padding: '12px', fontSize: "16px", color: "black" }}
                        >
                          {tempArr.section_name}
                        </InputLabel></Grid>

                    </Grid>
                    {tempArr.coaching_agreement_form_fields.map((row, i) => (
                      <Grid
                        container
                        direction="row"
                        alignItems="flex-start"
                      // style={{ marginBottom: 20, marginTop: 20, backgroundColor: '#F2F2F2' }}
                      >
                        <Grid
                          item
                          xs={10}
                        >
                          <InputLabel
                            className={classes.labelText}
                            style={{ fontWeight: "bold", padding: '12px', fontSize: "14px", color: "black", lineHeight: "22px" }}
                          >
                            {row.field_value}
                          </InputLabel></Grid>

                        <Grid
                          item
                          style={{ paddingTop: (row.field_type === "text_area" || row.field_type === "Text area") ? '20px' : '' }}
                          xs={
                            (row.field_type === "text_area" || row.field_type === "Text area") ? 9 : 4
                          }
                        >
                          <Grid
                            container
                            direction="row"
                            alignItems="center"
                            style={{ marginBottom: 20 }}
                          >
                            <Grid item xs={12}>
                              {(row.field_type === "text" || row.field_type === "Text") &&
                                (

                                  <CustomInput defaultValue={row.answer} id={row.id} variant="outlined" placeholder={"Answer"} parentcall={() => {
                                    setAdditionalSectionId(row.additional_section_id)
                                    setInputState()
                                  }} />

                                )}
                              {((row.field_type === "text_area" || row.field_type === "Text area") && row.field_value !== "Predominant Competency")
                                && (
                                  <CustomInput
                                    placeholder="Answers"
                                    multiline
                                    rows="4"
                                    id={row.id}
                                    defaultValue={row.answer}
                                    variant="outlined"
                                    onChange={() => {
                                      setAdditionalSectionId(row.additional_section_id)
                                      setInputState()
                                    }}

                                  />
                                )}
                            </Grid>
                          </Grid>
                          {row.organisation_metrics && row.organisation_metrics !== undefined && row.organisation_metrics.map(childRow => {
                            return (
                              <Grid item xs={6}>
                                {console.log("hello", row.answer !== null && row.answer !== undefined && (row.answer))}
                                {/* {console.log("childRow",row.answer!== null && row.answer !== undefined && Boolean(Object.keys(row.answer).filter((item, index) => Boolean(row.answer[item])) ))} */}
                                {/* <FormControlLabel
                                  control={
                                    <Checkbox
                                      name={childRow.name}
                                      color="primary"
                                      onChange={(e) => {
                                        setAdditionalSectionId(row.additional_section_id)
                                        setInputState(e.target.checked, row.id, childRow.id)
                                      }
                                      }
                                      checked={checkAnswer(row?.answer, +childRow?.id, row.id)}


                                    // checked={row.answer!== null && row.answer !== undefined && Boolean(row.answer[childRow?.id])}
                                    // checked={row.answer!== null && row.answer !== undefined &&row.answer[childRow.id]}
                                    //  checked={row.answer!== null && row.answer !== undefined && Boolean(Object.keys(row.answer).filter((item, index) => Boolean(childRow.id)) )} 
                                    // checked={Boolean(row.answer.name)}
                                    />
                                  }
                                  //   onChange={handleCheckboxValue}
                                  label={childRow.name}
                                //   className={classes.paper}
                                />

                              </Grid>

                            );
                          })}
                        </Grid>

                        <br />
                      </Grid>
                    ))}
                  </React.Fragment> */}
                {/* ))}  */}
                {/* <Paper style={{padding:'25px'}} elevation={1} > */}
                {CoachinRequest[index].coaching_agreement_form_fields.map((row) => (
                  <Grid
                    container
                    direction="row"
                    alignItems="flex-start"
                    style={{ marginBottom: 20 }}
                  >
                    <Grid
                      item
                      xs={
                        (row.field_name === "Description") ? 10 : (row.field_type === "text_area" || row.field_type === "Text area") ? 12 : 5}
                    >
                      <Typography >
                        <Box mb={2}>{row.field_value}</Box>
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      style={{ paddingTop: (row.field_type === "text_area" || row.field_type === "Text area") ? '20px' : '' }}
                      xs={
                        (row.field_type === "text_area" || row.field_type === "Text area") ? 9 : 4
                      }
                    >
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        style={{ marginBottom: 20 }}
                      >
                        <Grid item xs={12}>
                          {(row.field_type === "text" || row.field_type === "Text") &&
                            (

                              <CustomInput defaultValue={row.answer} id={row.id} variant="outlined" placeholder={row.field_value} parentcall={setInputState} />

                            )}
                          {(row.field_type === "text_area" || row.field_type === "Text area")
                            && (
                              <CustomInput

                                multiline
                                rows="4"
                                id={row.id}
                                defaultValue={row.answer}
                                variant="outlined"
                                parentcall={setInputState}

                              />
                            )}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={0}></Grid>
                    <Grid item xs={2}>


                    </Grid>

                  </Grid>
                ))}
                  {CoachinRequest[index].sub_heading.map((tempArr, addIndex) => (
                            <React.Fragment>
                              <Grid
                                container
                                direction="row"
                                alignItems="flex-start"
                                style={{ marginBottom: 20, marginTop: 20, }}
                              >
                                <Grid
                                  item
                                  xs={10}
                                >
                                  <InputLabel
                                    className={classes.labelText}
                                    style={{ fontWeight: "bold", padding: '12px', backgroundColor: '#F2F2F2' }}
                                  >
                                    <Typography variant="h2">
                                      {tempArr.sub_heading}
                                    </Typography>
                                  </InputLabel>
                                </Grid>
                                {/* <Grid item xs={2}>
                                  <IconButton
                                    onClick={() => {
                                      setAction("edit");
                                      setCrfSectionId(tempArr.coaching_request_form_id)
                                      setCurrentSelection(tempArr)
                                    }}
                                    edge="start"
                                  >
                                    <EditIcon
                                      style={{
                                        fontSize: 25,
                                        marginTop: "-3px",
                                      }}
                                    />
                                  </IconButton>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                </Grid> */}
                              </Grid>
                              {tempArr.coaching_agreement_form_fields.map((row, i) => (
                                <Grid
                                  container
                                  direction="row"
                                  alignItems="flex-start"
                                  style={{ marginBottom: 20, marginTop: 20, }}
                                >
                                   <Grid
                                        item
                                        xs={
                                          (row.field_type === "Description" || row.field_type === "description")
                                            ? 9
                                            : row.field_type === "Text area" ||
                                              row.field_type === "Description"
                                            ? 12
                                            : 5
                                        }
                                      >

                                    <InputLabel
                                      className={classes.labelText}
                                      style={{ padding: '12px' }}
                                    >
                                      <Typography variant="h2">
                                        {row.field_value}
                                      </Typography>
                                    </InputLabel>
                                   
                                  </Grid>
                                  <Grid
                              item
                              style={{ paddingTop: row.field_type === "Text area" ? '20px' : '' }}
                              xs={
                                row.field_value === "description" ? 0 : row.field_type === "Text area" ? 9 : 4
                              }
                            >
                              <Grid
                                container
                                direction="row"
                                alignItems="center"
                                style={{ marginBottom: 20 }}
                              >
                                <Grid item xs={12}>
                                  {(row.field_type === "text" || row.field_type === "Text") &&
                                    ( row.field_type !==
                                      "Description" ||
                                    row.field_type !==
                                      "description")
&& (
                                      <CustomInput
                                        // disabled
                                        id={row.id}
                                        variant="outlined"
                                        defaultValue={row.answer}
                                        parentcall={setInputState}
                                        // value={userData.first_name}
                                      />
                                    )}
                                  {(row.field_type === "text_area" || row.field_type === "Text area" ) && ( row.field_type !==
                                        "Description" ||
                                      row.field_type !==
                                        "description")

                                    && (
                                      <CustomInput
                                        // disabled
                                        multiline
                                        rows="4"
                                        id={row.id}
                                        variant="outlined"
                                        defaultValue={row.answer}
                                        parentcall={3}
                                        // value={userData.first_name}
                                      />
                                    )}
                                  {(row.field_type === "dropdown" || row.field_type === "Dropdown" || row.field_type === "Drop down") && (
                                                 <CustomSelect
                                                 id={row.id}
                                   labelText="Select a value"
                                   defaultValue={row.answer}
                                   displayEmpty
                                   variant="outlined"
                                   itemArr={row.option}
                                   parentcall={onChangeItem}
                                 
                                 />
                                  )}

                                </Grid>
                              </Grid>
                            </Grid>
                            {row.organisation_metrics && row.organisation_metrics !== undefined && row.organisation_metrics.map((row2,ind) => {
                                    console.log(row,"row data")
                                    if (!answerData[row.id] && ind === 0) {
                              console.log(row.id,"i render first");
                                setAnswerData(prev=>({...prev,
                                  [row.id]: [row.answer && row.answer.split(",")]
                                    .flatMap((el) => el)
                                    .reduce(
                                      (acc, x) => acc.concat(+x),
                                      []
                                    ),
                                }));

                                first = false;
                              }
                                    return (
                                      <Grid item xs={6}>
                                       <FormControlLabel
                                          control={
                                            <Checkbox
                                              name={row2.field_value}
                                              color="primary"
                                              id={row2.id}
                                              disabled
                                           
                                              // checked={row?.answer}
                                              checked={answerData[
                                                row.id
                                              ]?.includes(row2.id)}
                                            />
                                          }
                                          //   onChange={handleCheckboxValue}
                                          label={<Typography variant="h2">{row2.name}</Typography>}

                                            //   checked={Boolean(checkBoxValue[data?.name])}
                                            />
                                        
                                       
                                         
                  

                                      </Grid>

                                    );
                                  })}
                                  {(row.compteencies) && row.compteencies.map((item, index) => (
                                    <ListItem key={index}>
                                      <Checkbox
                                        // disabled
                                        // checked={state[item.value]}
                                        // onChange={handleChangeWO}
                                        name={item.name}
                                        id={row.id}
                                      />
                                      <Typography variant="h2">{item.name}</Typography>
                                    </ListItem>
                                  ))}
                                </Grid>
                              ))}
                           
                               {tempArr.objectives.map((row1, i) => (
                               <React.Fragment> 
                                  <Grid
                                 container
                                 direction="row"
                                 alignItems="flex-start"
                                 style={{ marginBottom: 20, marginTop: 20, backgroundColor: '#F2F2F2' }}
                               >
                                 <Grid
                                   item
                                   xs={10}
                                 >
                                   <InputLabel>
                                     <Typography variant="subtitle1" style={{ fontWeight: "bold", padding: '12px', color: "#4D4F5C", }}>
                                       {row1.objective_name}
                                     </Typography>
                                   </InputLabel>
                                 </Grid>
                               </Grid>
                               {row1.coaching_agreement_form_fields && row1.coaching_agreement_form_fields !== undefined && row1.coaching_agreement_form_fields.map((row, i) => (
                                <Grid
                                  container
                                  direction="row"
                                  alignItems="flex-start"
                                  style={{ marginBottom: 20, marginTop: 20, }}
                                >
                                  <Grid
                                    item
                                    xs={
                                      (row.field_value === "description") ? 10 : row.field_type === "Text area" ? 12 : 5}
                                  >
                                    <InputLabel
                                      className={classes.labelText}
                                      style={{ padding: '12px' }}
                                    >
                                      <Typography variant="h2">
                                        {row.field_value}
                                      </Typography>
                                    </InputLabel>
                                   
                                  </Grid>
                                  <Grid
                              item
                              style={{ paddingTop: row.field_type === "Text area" ? '20px' : '' }}
                              xs={
                                row.field_value === "description" ? 0 : row.field_type === "Text area" ? 9 : 4
                              }
                            >
                              <Grid
                                container
                                direction="row"
                                alignItems="center"
                                style={{ marginBottom: 20 }}
                              >
                                <Grid item xs={12}>
                                  {(row.field_type === "text" || row.field_type === "Text") &&
                                    row.field_value !== "description" && (
                                      <CustomInput
                                        // disabled
                                        id={row.id}
                                        variant="outlined"
                                        defaultValue={row.answer}
                                        parentcall={setInputState}
                                        // value={userData.first_name}
                                      />
                                    )}
                                  {(row.field_type === "text_area" || row.field_type === "Text area" || row.field_type === "Description")
                                    && (
                                      <CustomInput
                                        // disabled
                                        multiline
                                        rows="4"
                                        id={row.id}
                                        variant="outlined"
                                        defaultValue={row.answer}
                                        parentcall={setInputState}
                                        // value={userData.first_name}
                                      />
                                    )}
                                  {(row.field_type === "dropdown" || row.field_type === "Dropdown" || row.field_type === "Drop down") && (
                                    <Select
                                      helperText="Please select Location"
                                      variant="outlined"
                                      id={row.id}
                                      // disabled
                                      style={{ width: "100%" }}
                                      defaultValue={row.answer}
                                      inputProps={{
                                        id: "outlined-age-native-simple",
                                      }}
                                    ></Select>
                                  )}

                                </Grid>
                              </Grid>
                            </Grid>
                            {row.organisation_metrics && row.organisation_metrics !== undefined && row.organisation_metrics.map((row2,ind) => {
                             console.log(row,"rowData")
                             if (!answerData[row.id] && ind === 0) {
                              console.log(row.id,"i render second");
                                              setAnswerData(prev=>({...prev,
                                                [row.id]: [row.answer && row.answer.split(",")]
                                                  .flatMap((el) => el)
                                                  .reduce(
                                                    (acc, x) => acc.concat(+x),
                                                    []
                                                  ),
                                              }));

                                              first = false;
                                            }
                            
                                    return (
                                      <Grid item xs={6}>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              name={row2.field_value}
                                              color="primary"
                                              id={row2.id}
                                              // disabled
                                              onChange={(e) => setInputState( row2.id,row.id,false,true)}
                                              // checked={row?.answer}
                                              checked={answerData[
                                                        row.id
                                                      ]?.includes(row2.id)}
                                            />
                                          }
                                          //   onChange={handleCheckboxValue}
                                          label={<Typography variant="h2">{row2.name}</Typography>}
                                        //   className={classes.paper}
                                        />
                                        
{console.log('row?.answer} :>> ', row.answer, row2.id, row.answer === row2.id.toString(),userData,answerData)}

                                      </Grid>

                                    );
                                  })}
                                  {(row.compteencies) && row.compteencies.map((item, index) => (
                                    <ListItem key={index}>
                                      <Checkbox
                                        // disabled
                                        id={row.id}
                                        // checked={state[item.value]}
                                        // onChange={handleChangeWO}
                                        name={item.name}
                                      />
                                      <Typography variant="h2">{item.name}</Typography>
                                    </ListItem>
                                  ))}
                                </Grid>
                              ))}
                                </React.Fragment>
                              ))}
                            </React.Fragment>
                          ))} 

                <Grid
                  container
                  direction="row"
                  alignItems="flex-start"
                >
                  <Grid item xs={10}></Grid>
                  {/* {!hidden && <Grid item xs={2} style={{ height: "100%", overflow: "hidden" }} >
                    <Button disableElevation variant="contained" color="primary" className={classes.btnSearch}
                      onClick={handleSubmit}
                    >
                      {(value + 1) === CoachinRequest.length ? 'Submit' : "Submit"}
                    </Button>
                  </Grid>} */}
                  <Grid item xs={2}>

                    {/* <ScrollTop>
                      <Fab style={{ width: "40px", height: "20px" }} aria-label="scroll back to top">
                        <Button disableElevation variant="contained" color="primary" className={classes.btnSearch}
                          onClick={handleSubmit}
                        >
                          {(value + 1) === CoachinRequest.length ? 'Submit' : "Submit"}
                        </Button>        </Fab>
                    </ScrollTop>     */}

                    <div className={classes.stepperButtons}>
                      <Button disableElevation variant="contained" color="secondary" className={classes.btnSearch} style={{ textTransform: "none" }}
                        onClick={handleSubmit}
                      >
                        {(value + 1) === CoachinRequest.length ? 'Save' : "Save"}
                      </Button>
                    </div>
                  </Grid>

                </Grid>

              </TabPanel>
            );
          })}
        </Box>

      </Grid>
    </Grid>
  </>



}

